//Necessary Imports for MyResulsts
import React, {useState, useEffect, useContext } from "react";
import axios from "axios";
import { Link,useSearchParams,useNavigate } from 'react-router-dom';
import SglContext from "../SglContext";
import video_icon from "../images/video_icon.png";
import VideoPlayer from "../videos/VideoPlayer";
import Popup from 'reactjs-popup';


function MyResults(props){

    const[searchParam,setSearchParam]=useSearchParams()
    const Sgl = useContext(SglContext)
    const navigate = useNavigate();

    
//States
    
    const [entry_x_classes, setEntry_x_classes] = useState([])
    const [show_name, setShow_name] = useState('')
    const [current_show, setCurrent_show] = useState(localStorage.getItem("show_id"))
    const [loading, setLoading] = useState(true)
    const [userData, setUserData] = useState({})
    
    const [is_admin, setIs_admin] = useState(false)

// Video States
    const [is_videos_enabled, setIs_videos_enabled] = useState(false)
    const [videos_list, setVideos_list] = useState([])
    const [video_to_play, setVideo_to_play] = useState({})
    const [playing_video, setPlaying_video] = useState(false)
    const [is_open_play_video_modal, setIs_open_play_video_modal] = useState(false)
    const [is_open_do_subscription_modal, setIs_open_do_subscription_modal] = useState(false)
    const [VideoPlayerElement, setVideoPlayerElement] = useState(null);
    const [VideoSubscriptionElement, setVideoSubscriptionElement] = useState(null);
    // Api EndPoints
    const sgl_webservice_my_results = Sgl.nestApiUrl+'/results/my';
    const sgl_webservice_video_to_play = Sgl.nestApiUrl+'/videos/play/';
    const user_info_url = Sgl.nestApiUrl+'/users/getUser';


// ComponentDidMount, This effect will trigger first
    useEffect(() => { 
        getAllData(current_show);
    }, [Sgl.currentTeamId])

    function getMyResultsData(show){
      getMyResultVideos(show);

        axios.get(sgl_webservice_my_results,{
          params : {
            show_id : show,
            customer_id: Sgl.company_id,
            login_user_id: Sgl.current_user,
            team_id: Sgl.currentTeamId != 'personal'?Sgl.currentTeamId:0,
          }
        }).then(res => {
        setEntry_x_classes(res.data.entry_x_classes)
        setCurrent_show(res.data.show_id)
        setShow_name(res.data.show_name)
        setIs_videos_enabled(res.data.is_videos_enabled)
        setLoading(false)

          document.title = "My Results for " + res.data.show_name;
          Sgl.reportToGA('/sgl-wp-plugin/'+Sgl.company_urlpath+'/'+show+'/results/my'); //For Google Analytics
          Sgl.reportToFB('/sgl-wp-plugin/'+Sgl.company_urlpath+'/'+show+'/results/my'); //For Facebook Analytics
        })
    }

    
    function getMyResultVideos(show){
      axios.get(sgl_webservice_my_results+'/videos',{
          params : {
            show_id : show,
            customer_id: Sgl.company_id,
          }
        })
      .then((res) => {
        setVideos_list(res.data.exc_videos)
      });
    }
    
    function getAllData(show){   
      getUserData();
      getMyResultVideos(show);

        axios.all([
            axios.get(sgl_webservice_my_results,{
            params : {
                show_id : show,
                customer_id: Sgl.company_id,
                login_user_id: Sgl.current_user.sgl_id,
                team_id: Sgl.currentTeamId != 'personal'?Sgl.currentTeamId:0,
            }
            }) 
        ]).then(axios.spread((results) => {
            setEntry_x_classes(results.data.entry_x_classes)
            setCurrent_show(results.data.show_id)
            setShow_name(results.data.show_name)
            setIs_videos_enabled(results.data.is_videos_enabled)
            setLoading(false)
            document.title = "My Results for " + results.data.show_name;
            Sgl.reportToGA('/sgl-wp-plugin/'+Sgl.company_urlpath+'/'+show+'/results/my');
            Sgl.reportToFB('/sgl-wp-plugin/'+Sgl.company_urlpath+'/'+show+'/results/my');
        })) 
      
    }

    function onChangePage(page) {
      getMyResultsData(current_show);
    }

    function onShowChange(show_id) {
      localStorage.setItem('show_id', show_id);
      getMyResultsData( show_id);
    }

    function format_placing(placing){
        if (placing > 0){
          var i=placing%10;
          var place=placing.toString().substring(placing.length-2);
      
          if(i==1 && place!='11'){
              return placing+'<sup>st</sup>';
          }
          else if(i==2 && place!='12'){
              return placing+'<sup>nd</sup>';
          }
          else if(i==3 && place!='13'){
              return placing+'<sup>rd</sup>';
          }
          return placing+'<sup>th</sup>';
        } else {
          return '-';
        }
      }


      function getUserData(){
        axios.get(user_info_url)
        .then((response) => {
          if(response.data.user && response.data.user != null){
            setUserData(response.data.user)
          }else{
          }
        }, (error) => {
        });
      }

      ////////////// video functions ////////////
      function getVideosList(uuid){
        var trip = videos_list.find(v => (v.uuid == uuid));
        if(trip) {
          var videos = trip.videos;
          return videos;
        }
        return [];
      }
      function playFirstVideoFromList(uuid){
        var trip = videos_list.find(v => (v.uuid == uuid));
        if(trip) {
          playVideoAPICall(trip.videos[0].sgl_id)
        }
        return;
      }
      const playVideo = (video_id) => (e) => {
        playVideoAPICall(video_id);
      }
      function playVideoAPICall(video_id){
        localStorage.setItem('playing_video_id', video_id);
        localStorage.setItem('playing_video_url', window.location.pathname.replace(Sgl.basePath, '') + window.location.search);
        axios.get(sgl_webservice_video_to_play+video_id,{
          params : {
              customer_id: Sgl.company_id
          }
        })
        .then((res) => {
          closeSubscriptionModal();
          localStorage.removeItem("playing_video_id");
          localStorage.removeItem("playing_video_url");
          if (res.data.subscribed_to_play){
            setVideo_to_play(res.data.video)
            setIs_admin(res.data.is_admin)
            setIs_open_play_video_modal(true)
            setPlaying_video(true)
          } else {
            setVideo_to_play(res.data.video)
            setIs_admin(res.data.is_admin)
            setIs_open_do_subscription_modal(true)
            setPlaying_video(true)
          }
        });
      }
      function playVideoAfterSubscribe(){
        playVideoAPICall(video_to_play.videos_sgl_id);
        setPlaying_video(true)
      }
  
      function closeModal() {
        setIs_open_play_video_modal(false)
        setPlaying_video(false)
      }
      function closeSubscriptionModal() {
        setIs_open_do_subscription_modal(false)
        setPlaying_video(false)
        
      }
      
      function getVideoTitle(video){
        if(video['class_type'] == 'Jumpers'){
          if(video['trip_type'].toLowerCase() != 'jo'){
            return " - Round 1";
          }else{
              return " - Jump Off";
          }
        }
      }
///////////// end video functions ///////////////////////  

      if(loading) {
        return null;
      }

      return(
        <div className="section-to-print">
        <section className="search-area">
          <h2 className="sgl-h2">My Results for {show_name}</h2>
          <div className='credit-text'> {process.env.REACT_APP_CREDIT_TEXT}{" "} <a onClick={() => window.open(`https://www.showgroundslive.com`, '_blank', 'noopener,noreferrer')}> {process.env.REACT_APP_CREDIT_COMPANY} </a> </div><br/>
          { (entry_x_classes.length > 0) ?
              <div className="div-responsive">             
                <table className="table table-hover table-striped">
                  <thead className="classes-header">
                    <tr className="sgl-primary-header">
                        { (is_videos_enabled == true) &&
                          <th nowrap="nowrap"></th>
                        }
                        <th className='center-align'>Placing</th>
                        <th className='center-align'>Entry</th>
                        <th>Horse</th>
                        <th>Rider</th>
                        <th>Class</th>
                    </tr>
                  </thead>
                  <tbody>             
                    { 
                      entry_x_classes.map((data, index) => {
                        return (
                            <tr className="sgl-anchor">
                                { (is_videos_enabled == true) &&
                                  <td><a>
                                    {(getVideosList(data.entryxclasses_uuid).length > 0) ?
                                      <Popup trigger={<img src={video_icon} className="video-icon" onClick={()=>playFirstVideoFromList(data.entryxclasses_uuid)}/>} on="hover" position="right center">
                                        <div>
                                          <ul className='popup-ul'>
                                            {getVideosList(data.entryxclasses_uuid).map((v_data,index) => { 
                                              return(
                                                <li className='class_list_li'><a onClick={playVideo(v_data.sgl_id)} >{v_data.class_number} - {v_data.class_name}{getVideoTitle(v_data)}</a></li>
                                                )
                                            })}
                                          </ul>
                                        </div>
                                      </Popup>
                                    :
                                      ''
                                    }
                                  </a></td>
                                }
                                <td class='center-align' className={'place_'+data.placing+' placings_data'}>
                                <span className="textChanges" dangerouslySetInnerHTML={{ __html: format_placing(data.placing) }} />
                                </td>
                                <td className='center-align'>

                                    <Link to={`/entries/detail?eid=${data.entry_id}&sid=${current_show}`}>{data.entry_number}</Link>
                                </td>
                                <td>
                                    <Link to={`/entries/detail?eid=${data.entry_id}&sid=${current_show}`}>{data.horse}</Link>
                                </td>
                                <td>
                                    <Link to={'/people/detail?pid='+data.rider_id+'&sid='+current_show}>{data.rider_name}</Link>
                                </td>
                                <td>
                                    <Link to={'/classes/detail?cid='+data.class_id+'&sid='+current_show}>{data.class_name}
                                    {((data.sponsor) ? <span className='sponsor_text'> (Sponsored By: {data.sponsor})</span>:"")}</Link>
                                </td>
                          </tr>
                        )
                      })
                    }                   
                    
                  </tbody>
                </table>
              </div>
          :
            <table>
              <tbody>
                <tr>
                  <td>No records found.</td>
                </tr>
              </tbody>
            </table>
          }
          <div>
                {(playing_video) &&
                    <VideoPlayer 
                      is_open_play_video_modal = {is_open_play_video_modal} 
                      is_open_do_subscription_modal = {is_open_do_subscription_modal}
                      is_download_subscription = {false}
                      video_to_play = {video_to_play} 
                      is_admin = {is_admin}
                      closeModal = {closeModal} 
                      closeSubscriptionModal = {closeSubscriptionModal} 
                      playing_preview = {false} 
                      play_video_path = {video_to_play.video_url}
                      playVideoAfterSubscribe = {playVideoAfterSubscribe}
                      VideoSubscriptionElement = {VideoSubscriptionElement}
                      ref = {VideoPlayerElement}
                    />
                }
          </div>
          <div className="copyright-text">{process.env.REACT_APP_COPYRIGHT_TEXT}</div>
        </section>
        </div>
      )
}
export default MyResults